import type { ReactNode } from "react";
import React from "react";
import { Row } from "react-bootstrap";
import { LandingContainer } from "./LandingContainer";

interface Props {
	title: ReactNode;
}

export class LandingHowTo extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { title, children } = this.props;

		return (
			<LandingContainer bgClassName="how-to">
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">{title}</h2>
				<Row>{children}</Row>
			</LandingContainer>
		);
	}
}
